import './Discounts.css'
import React from 'react'
import '../../css/table.css'
import ReactTable from 'react-table'
import { orderBy, isEmpty } from 'lodash'
import Card from 'components/Card/Card.jsx'
import { db } from '../../services/firebase'
import Modal from 'components/Modal/Modal.jsx'
import SweetAlert from 'react-bootstrap-sweetalert'
import Button from 'elements/CustomButton/CustomButton.jsx'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import DiscountConditionForm from '../../forms/DiscountConditionForm.jsx'
import { Grid, Row, Col, OverlayTrigger, Tooltip, Breadcrumb } from 'react-bootstrap'

export default class DiscountConditions extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            conditions: [],
            loading: false,
            conditionModal: false,
            alert: null,
            targetCondition: null,
            currentDiscount: {}
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount() {
        const { discountID } = this.props.match.params
        this._fetchDiscount(discountID)
    }

    render() {
        const { conditions, alert, loading, currentDiscount } = this.state

        return (
            <div className='main-content'>
                {alert}
                {this.conditionModal()}
                <Breadcrumb style={{ padding: 0, marginBottom: 7, marginTop: 10 }}>
                    <Breadcrumb.Item onClick={() => this.props.history.push('/discounts')}>
                        <FontAwesomeIcon icon='chevron-left' className='text-default' /> <span className='text-default'>Descontos</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href='#' active>
                        <b>{!isEmpty(currentDiscount) ? currentDiscount.name : '...'}</b>
                    </Breadcrumb.Item>
                </Breadcrumb>

                <Card
                    title={!isEmpty(currentDiscount) ? currentDiscount.name : '...'}
                    category={
                        !isEmpty(currentDiscount)
                            ? <span>Frete {currentDiscount.freight}</span>
                            : '...'
                    }
                    content={
                        <Grid fluid style={{ position: 'relative' }}>
                            <Button
                                bsStyle='default'
                                wd
                                className='add_condition_button'
                                style={{ marginBottom: 10 }}
                                onClick={() => {
                                    // this.props.resetForm('DiscountForm')
                                    this.setState({ conditionModal: true, targetCondition: null })
                                }}
                            >
                                Adicionar Condição
                            </Button>
                            <Row>
                                <Col md={12}>
                                    <Card content={
                                        <ReactTable
                                            columns={[
                                                { Header: 'Nome', accessor: 'name' },
                                                { Header: 'Desconto Enele (%)', accessor: 'eneleDiscount' },
                                                { Header: 'Desconto Nube (%)', accessor: 'nubeDiscount' },
                                                {
                                                    Header: 'Ações', accessor: '',
                                                    Cell: ({ value }) => (this._renderTableActions(value))
                                                }
                                            ]}
                                            data={orderBy(conditions, ['discount'], ['desc'])}
                                            onFetchData={this._fetchConditions}
                                            loading={loading}
                                            defaultPageSize={10}
                                            className='-striped -highlight'
                                            previousText='Anterior'
                                            nextText='Próximo'
                                            loadingText='Carregando'
                                            noDataText='Nenhuma condição encontrada'
                                            pageText='Página'
                                            ofText='de'
                                            rowsText='Registros'
                                        />
                                    } />
                                </Col>
                            </Row>
                        </Grid>
                    }
                />
            </div>
        )
    }

    conditionModal = () => {
        const { conditionModal, targetCondition } = this.state
        return (
            <Modal
                className='modal__big'
                title={targetCondition ? 'Atualizar condição' : 'Adicionar condição'}
                isOpen={conditionModal}
                content={
                    <DiscountConditionForm
                        initialValues={targetCondition}
                        onSubmit={values => targetCondition ? this._updateCondition(values) : this._addCondition(values)}
                        handleCancel={() => this.setState({ conditionModal: false })}
                    />
                }
            />
        )
    }

    _renderTableActions = value => (
        <div style={{ textAlign: 'center' }}>
            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.setState({ targetCondition: value, conditionModal: true })}
                >
                    <FontAwesomeIcon className='text-dark' icon='edit' />
                </a>
            </OverlayTrigger>

            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.removeConditionAlert(value.id)}
                >
                    <FontAwesomeIcon className='text-dark' icon='trash' />
                </a>
            </OverlayTrigger>
        </div>
    )

    /**************** 
       Fetch data from Firestore
   *****************/

    _fetchDiscount = discountID => {
        db.collection('discounts').doc(discountID).get()
            .then(snapshot => {
                if (snapshot.exists) {
                    this.setState({ currentDiscount: { ...snapshot.data() } })
                } else {
                    this.props.history.push('/discounts')
                }
            })
            .catch(e => {
                console.log(e)
                this.props.notify('Erro ao buscar desconto.', 'error')
                this.props.history.push('/discounts')
            })
    }

    // _fetchProductLine = discountSnapshot => {
    //     db.collection('products_lines').doc(discountSnapshot.productLine).get()
    //         .then(snapshot =>
    //             snapshot.exists
    //                 ? this.setState({ currentDiscount: { ...discountSnapshot, productLine: snapshot.data().name } })
    //                 : this.props.history.push('/discounts')
    //         )
    //         .catch(e => {
    //             this.props.notify('Erro ao buscar linha de produtos.', 'error')
    //             this.props.history.push('/discounts')
    //         })
    // }

    _fetchConditions = () => {
        const { discountID } = this.props.match.params

        this.setState({ loading: true })
        db.collection('discounts').doc(discountID).collection('conditions').onSnapshot(snapshot =>
            !snapshot.empty
                ? this._passConditionsToState(snapshot)
                : this.setState({ loading: false })
        )
    }

    _passConditionsToState = conditionsSnapshot => {
        const conditions = []
        conditionsSnapshot.forEach(condition => conditions.push({ ...condition.data(), id: condition.id }))
        return this.setState({ conditions, loading: false })
    }

    /**************** 
        Add data to Firestore
    *****************/

    _addCondition = data => {
        const { discountID } = this.props.match.params

        this.setState({ conditionModal: false })
        this.waitAlert('Adicionando condição', true)
        db.collection('discounts').doc(discountID).collection('conditions').add({
            name: data.name,
            eneleDiscount: data.eneleDiscount,
            nubeDiscount: data.nubeDiscount
        })
            .then(() => {
                this.hideAlert()
                this.props.notify('Condição adicionado.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao adicionar condição.', 'error')
            })
    }

    /**************** 
        Update Firestore data
    *****************/

    _updateCondition = data => {
        this.setState({ conditionModal: false })
        this.waitAlert('Atualizando condição', true)

        const { targetCondition } = this.state
        const { discountID } = this.props.match.params

        db.collection('discounts').doc(discountID).collection('conditions').doc(targetCondition.id).update({
            //stripes ID from data object 
            name: data.name,
            eneleDiscount: data.eneleDiscount,
            nubeDiscount: data.nubeDiscount
        })
            .then(() => {
                this.hideAlert()
                this.setState({ targetCondition: null })
                this.props.notify('Condição atualizada.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.setState({ targetCondition: null })
                this.props.notify('Erro ao atualizar condição.', 'error')
            })
    }

    /**************** 
        Remove Firestore data
    *****************/

    _removeCondition = conditionID => {
        this.hideAlert()
        this.waitAlert('Removendo condição', false)

        const { discountID } = this.props.match.params

        db.collection('discounts').doc(discountID).collection('conditions').doc(conditionID).delete()
            .then(() => {
                this.hideAlert()
                this.props.notify('Condição removida.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao remover condição.', 'error')
            })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    removeConditionAlert = conditionID => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Remover esta condição?"
                    onConfirm={() => this._removeCondition(conditionID)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                />
            )
        });
    }
}


// WEBPACK FOOTER //
// ./src/views/Discounts/DiscountConditions.jsx